module.exports = __webpack_public_path__ + "static/media/heater_on.20747e49.png";